import { makeStyles } from '@material-ui/core/styles';
import { rgba } from 'polished';

const useStyles = makeStyles({
  dialog: (props) => ({
    zIndex: 1997,
    '& .MuiPaper-root::-webkit-scrollbar': {
      width: '10px',
      cursor: 'pointer',
      background: 'transparent',
    },

    '& .MuiPaper-root::-webkit-scrollbar-track': {
      background: '#D7DCE0',
      borderRadius: '10px',
    },

    '& .MuiPaper-root::-webkit-scrollbar-thumb': {
      backgroundColor:
        props?.primaryColor !== ''
          ? props.primaryColor
          : 'var(--color-blue-primary)',
      borderRadius: '20px',
      border: '1px solid #D7DCE0',
    },
  }),
  cardContent: {
    width: '100%',
    boxSizing: 'border-box',
  },
  card: {
    width: '100%',
    maxWidth: '470px',
    //height: '100vh',
    maxHeight: '700px',
    overflowY: 'auto !important',
  },
  cardInfo: {
    boxShadow: '0px 3px 15px #0000001A',
    border: '1px solid #D7DCE0',
    marginBottom: '22px',
    marginTop: '12px',
    position: 'sticky',
    zIndex: 1997,
  },
  cardInfoHours: (props) => ({
    boxShadow: '0px 3px 15px #0000001A',
    border: '1px solid #D7DCE0',
    marginBottom: '22px',
    marginTop: '12px',
    maxHeight: '200px',
    overflowX: 'auto',
    overflowY: 'scroll !important',
    '& .MuiPaper-root': {
      overflow: 'auto',
    },
    '&::-webkit-scrollbar': {
      width: '10px',
      cursor: 'pointer',
      background: 'transparent',
    },

    '&::-webkit-scrollbar-track': {
      background: '#D7DCE0',
      borderRadius: '10px',
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor:
        props?.primaryColor !== ''
          ? props.primaryColor
          : 'var(--color-blue-primary)',
      borderRadius: '20px',
      border: '1px solid #D7DCE0',
    },
  }),
  media: {
    width: '100%',
    height: '274px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 768px)': {
      height: 'auto',
    },
  },
  rowContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    padding: '14px 20px',
    borderTop: '1px solid #d7dce0',
    gap: '10px',
    '&:first-child': {
      borderTop: 'none',
    },
    '@media (max-width: 475px)': {
      padding: '10px 12px',
    },
  },
  justifyBetween: {
    justifyContent: 'space-between',
  },
  accordion: {
    '&.Mui-expanded': {
      borderTop: '1px solid #d7dce0',
      margin: '0px !important',
    },
  },
  accordionSummary: {
    padding: '0px 20px !important',
    '& > div': {
      gap: '10px',
      margin: '14px 0px',
    },
    '&.Mui-expanded': {
      maxHeight: '53px',
      minHeight: '53px !important',
      margin: '0px',
    },
    '@media (max-width: 475px)': {
      padding: '0px 12px !important',
      '&.Mui-expanded': {
        maxHeight: '39px',
        minHeight: '39px !important',
        margin: '0px',
      },
    },
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
  },
  titleName: (props) => ({
    fontFamily:
      props?.fontFamily !== ''
        ? props.fontFamily
        : 'var(--font-family-primary)',
    fontSize: '1.1rem',
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: '0px',
    color: '#3A3A3A',
  }),
  text: (props) => ({
    fontFamily:
      props?.fontFamily !== ''
        ? props.fontFamily
        : 'var(--font-family-primary)',
    textAlign: 'left',
    fontSize: '0.9rem',
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: '0px',
    color: '#3A3A3A',
    '@media (max-width: 475px)': {
      fontSize: '0.7rem',
    },
  }),
  label: (props) => ({
    fontFamily:
      props?.fontFamily !== ''
        ? props.fontFamily
        : 'var(--font-family-primary)',
    textAlign: 'left',
    fontSize: '0.9rem',
    fontWeight: 'normal',
    fontStyle: 'normal',
    textTransform: 'uppercase',
    color: '#4E4E4E',
    marginTop: '23px',
    marginBottom: '10px',
  }),
  iconSVG: (props) => ({
    '& path': {
      stroke:
        props?.primaryColor !== ''
          ? props.primaryColor
          : 'var(--color-blue-primary)',
    },
    '& path:first-child': {
      stroke: 'transparent',
    },
    '@media (max-width: 475px)': {
      width: 18,
    },
  }),
  marginTop_50: {
    marginTop: '-50px',
  },
  buttonNextStep: (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '44px',
    border: 'none',
    background:
      props?.primaryColor !== ''
        ? props.primaryColor
        : 'var(--color-blue-primary)',
    color:
      props?.fontColorSecondary !== '' ? props.fontColorSecondary : '#ffffff',
    marginBottom: '20px',
    fontFamily:
      props?.fontFamily !== ''
        ? props.fontFamily
        : 'var(--font-family-primary)',
    fontSize: '1rem',
    textAlign: 'center',
    padding: '14px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      background:
        props?.primaryColor !== ''
          ? rgba(props.primaryColor, 0.7)
          : 'var(--color-blue-50)',
    },
  }),
  buttonClose: (props) => ({
    border: 'none',
    background: 'transparent',
    width: 35,
    height: 35,
    position: 'absolute',
    right: '10px',
    top: '10px',
    color:
      props?.primaryColor !== ''
        ? props.primaryColor
        : 'var(--color-blue-primary)',
    fontSize: '20px',
    cursor: 'pointer',
    zIndex: 10,
  }),
  tableContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
  },
  tableItem: (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '35px',
    fontSize: '0.8rem',
    padding: '2px',
    overflowWrap: 'anywhere',
    fontWeight: 600,
    border:
      props?.primaryColor !== ''
        ? `1px solid ${props.primaryColor}`
        : '1px solid var(--color-blue-primary)',
    '&:first-child': {
      width: '100px',
    },
    fontFamily:
      props?.fontFamily !== ''
        ? props.fontFamily
        : 'var(--font-family-primary)',
  }),
  howToGoButton: (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '44px',
    background: 'transparent',
    color:
      props?.fontColor !== '' ? props.fontColor : 'var(--color-blue-primary)',
    fontFamily:
      props?.fontFamily !== ''
        ? props.fontFamily
        : 'var(--font-family-primary)',
    fontSize: '1rem',
    textAlign: 'center',
    padding: '14px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    border:
      props?.primaryColor !== ''
        ? `1px solid ${props.primaryColor}`
        : '1px solid var(--color-blue-primary)',
    '&:first-child': {
      width: '100px',
    },
    textDecoration: 'none',
    marginBottom: '10px',
    '&:hover': {
      background: '#F5F5F5',
    },
  }),
});

export default useStyles;
